const tiposCuenta = [
  { label: 'Efectivo', id: '1' },
  { label: 'Tarjeta', id: '2' },
  { label: 'Transferencia', id: '3' },
  { label: 'Cheque', id: '4' },
];

export default tiposCuenta
